import { render, staticRenderFns } from "./TransferScreensaversForm.vue?vue&type=template&id=138d897e&scoped=true"
import script from "./TransferScreensaversForm.vue?vue&type=script&lang=js"
export * from "./TransferScreensaversForm.vue?vue&type=script&lang=js"
import style0 from "./TransferScreensaversForm.vue?vue&type=style&index=0&id=138d897e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138d897e",
  null
  
)

export default component.exports